import React, { useRef, useState } from "react";
import { X } from "lucide-react";
import SignaturePad from "./SignaturePad";
import { Spinner } from "./ui/kit";

// Podpis se kreslí v ploše vyjeté zespodu, ne v malém rámečku v formuláři —
// klient podepisuje prstem na telefonu a potřebuje na to celou šířku.
// Bez `onJmeno` (podpis technika) se jméno nezadává — je to přihlášený uživatel.
export default function PodpisSheet({ titulek = "Podpis klienta", jmeno, onJmeno, onClose, onSave }) {
  const sigRef = useRef(null);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const uloz = async () => {
    const dataUrl = sigRef.current?.getDataURL();
    if (!dataUrl) return setErr("Nejdřív se podepiš.");
    setErr(""); setSaving(true);
    try {
      await onSave(dataUrl);
      onClose();
    } catch (e) {
      setErr("Podpis se nepodařilo uložit.");
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-end md:items-center justify-center md:p-4" data-testid="podpis-sheet">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white w-full md:max-w-[640px] rounded-t-sheet md:rounded-card shadow-panel">
        <div className="px-5 py-4 border-b border-line-softer flex items-center justify-between">
          <h2 className="text-[15px] font-800 text-ink">{titulek}</h2>
          <button onClick={onClose} className="text-muted hover:text-ink" data-testid="podpis-sheet-close"><X size={20} /></button>
        </div>

        <div className="p-5 space-y-3">
          <SignaturePad ref={sigRef} height={220} />
          <div className="flex items-center justify-between">
            <span className="text-[12px] text-muted">Podepiš prstem do rámečku.</span>
            <button onClick={() => sigRef.current?.clear()} className="text-[12.5px] font-600 text-accent"
              data-testid="podpis-sheet-smazat">Smazat</button>
          </div>
          {onJmeno && (
            <input value={jmeno} onChange={(e) => onJmeno(e.target.value)} placeholder="Jméno podepisujícího"
              className="field text-[13px]" data-testid="podpis-sheet-jmeno" />
          )}
          {err && <div className="text-[12.5px] text-danger" data-testid="podpis-sheet-error">{err}</div>}
        </div>

        <div className="px-5 pb-5 pt-1 flex gap-2">
          <button onClick={onClose} className="btn-ghost h-11 px-5">Zrušit</button>
          <button onClick={uloz} disabled={saving} data-testid="podpis-sheet-ulozit"
            className="btn-primary flex-1 h-11 justify-center">{saving ? <Spinner /> : "Uložit podpis"}</button>
        </div>
      </div>
    </div>
  );
}
